<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.705 12L10.4104 6.70535C10.0208 6.31578 9.38919 6.31578 8.99962 6.70535C8.61034 7.09463 8.61 7.72566 8.99885 8.11535L12.875 12L8.99885 15.8846C8.61 16.2743 8.61034 16.9053 8.99962 17.2946C9.38919 17.6842 10.0208 17.6842 10.4104 17.2946L15.705 12Z" fill="currentColor"/>
</svg>
